var _circle, _g, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThirdPlace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 34,
    viewBox: "0 0 30 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.9849,
    cy: 15.502,
    r: 13.3198,
    fill: "#B76F0E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3455_40641)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15.0059,
    cy: 15.4942,
    r: 10.6559,
    transform: "rotate(50.7384 15.0059 15.4942)",
    fill: "url(#paint0_linear_3455_40641)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M14.7249 15.1504C12.7864 22.6017 6.9731 22.524 6.9731 22.524C6.9731 22.524 0.125984 14.8959 8.26223 7.2437C16.779 1.05913 23.2564 8.75047 23.2564 8.75047C23.2564 8.75047 16.6634 7.69904 14.7249 15.1504Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9709 21.1591C14.1224 21.1591 13.3667 21.0133 12.7038 20.7216C12.0447 20.4261 11.5239 20.0208 11.1413 19.5057C10.7625 18.9867 10.5675 18.3883 10.5561 17.7102H13.0334C13.0485 17.9943 13.1413 18.2443 13.3118 18.4602C13.486 18.6723 13.7171 18.8371 14.005 18.9545C14.2929 19.072 14.6167 19.1307 14.9766 19.1307C15.3516 19.1307 15.683 19.0644 15.9709 18.9318C16.2588 18.7992 16.4841 18.6155 16.647 18.3807C16.8099 18.1458 16.8913 17.875 16.8913 17.5682C16.8913 17.2576 16.8042 16.983 16.63 16.7443C16.4595 16.5019 16.2133 16.3125 15.8913 16.1761C15.5732 16.0398 15.1944 15.9716 14.755 15.9716H13.6697V14.1648H14.755C15.1262 14.1648 15.4538 14.1004 15.7379 13.9716C16.0258 13.8428 16.2493 13.6648 16.4084 13.4375C16.5675 13.2064 16.647 12.9375 16.647 12.6307C16.647 12.339 16.5769 12.0833 16.4368 11.8636C16.3004 11.6402 16.1072 11.4659 15.8572 11.3409C15.611 11.2159 15.3232 11.1534 14.9936 11.1534C14.6603 11.1534 14.3554 11.214 14.0788 11.3352C13.8023 11.4527 13.5807 11.6212 13.4141 11.8409C13.2474 12.0606 13.1584 12.3182 13.147 12.6136H10.7891C10.8004 11.9432 10.9917 11.3523 11.3629 10.8409C11.7341 10.3295 12.2341 9.92992 12.8629 9.64205C13.4955 9.35038 14.2095 9.20455 15.005 9.20455C15.808 9.20455 16.5107 9.35038 17.1129 9.64205C17.7152 9.93371 18.183 10.3277 18.5163 10.8239C18.8535 11.3163 19.0201 11.8693 19.0163 12.483C19.0201 13.1345 18.8175 13.678 18.4084 14.1136C18.0031 14.5492 17.4747 14.8258 16.8232 14.9432V15.0341C17.6792 15.1439 18.3307 15.4413 18.7777 15.9261C19.2285 16.4072 19.4519 17.0095 19.4482 17.733C19.4519 18.3958 19.2607 18.9848 18.8743 19.5C18.4917 20.0152 17.9633 20.4205 17.2891 20.7159C16.6148 21.0114 15.8421 21.1591 14.9709 21.1591Z",
    fill: "#FFE9D8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3455_40641",
    x: 0.797651,
    y: 4.83789,
    width: 28.4164,
    height: 28.4164,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.55196
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.77598
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3455_40641"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3455_40641",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3455_40641",
    x1: 14.797,
    y1: 3.68745,
    x2: 21.2824,
    y2: 27.0452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#904907"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThirdPlace);
export default __webpack_public_path__ + "static/media/third_place.76c75a1bc3e411849d57b6287f9e0356.svg";
export { ForwardRef as ReactComponent };